import React from "react";
import "./../../styles/businessnavbar.scss";

function InventoryNavBar(){
    return(
        <div className ="main-header">
            <a className ="menu-link-main" href="#">All Apps</a>
            <div className ="header-menu">
                <a className ="main-header-link" href="#">Summary</a>
                <a className ="main-header-link is-active" href="#">Add Inventory</a>
                <a className ="main-header-link" href="#">Release Inventory</a>
                <a className ="main-header-link" href="#">Future Inventory</a>
            </div>
        </div>
    );
}

export {InventoryNavBar};